import type { CallAttempt, Order, CallBlock } from "~/features/orders/types-order";

export type Metrics = {
    ready_to_call: number;
    callbacks_waiting: number;
    transfers_waiting: number;
    confirmation_rate: number;
    scheduled_today: number;
    scheduled_future: number;
    scheduled_total: number;
    active_blocks: number;
};

export type TransferPreview = { order: Order; reason: string };

export type NavPreview = { id: number; created_at: number; count: number };

export type DashboardState = {
    metrics: Metrics;
    nextOrders: Order[];
    transferQueue: TransferPreview[];
    callbacks: CallAttempt[];
    navOutbox: NavPreview[];
    blocks: CallBlock[];
};

export type QuickAction = {
    title: string;
    description: string;
    icon: string;
    buttonLabel: string;
    variant: "primary" | "secondary" | "danger";
    href: string;
};

export const defaultMetrics: Metrics = {
    ready_to_call: 0,
    callbacks_waiting: 0,
    transfers_waiting: 0,
    confirmation_rate: 0,
    scheduled_today: 0,
    scheduled_future: 0,
    scheduled_total: 0,
    active_blocks: 0,
};
